<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.task_type.delete_bill')}}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('bill.text_244')" :count="params.data.length" :action="$t('bill.task_type.delete_bill')" />
      <dialog-table :data="params.data" :columns="params.columns.slice(0,3)" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BillDeleteDialog',
  components: {
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
    }
  },
  created () {
    this.$bM = new this.$Manager('billtasks/submit', 'v1')
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await this.$bM.create({
          data: {
            account_id: this.params.data[0].account_id,
            task_type: 'delete_bill',
          },
        })
        this.params.ok && this.params.ok()
        this.cancelDialog()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
